import React, { useState } from "react";
import "./SubmitTitle.css";
import {
  TextField,
  Button,
  Box,
  Grid,
  IconButton,
  MenuItem,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { mockResults } from "../../utils/mockResponseData.js";
import RenderResponse from "../RenderResponse/RenderResponse.js";

const languages = [
  "Hindi",
  "Tamil",
  "Telugu",
  "Bengali",
  "Gujarati",
  "Marathi",
  "Punjabi",
  "Malayalam",
  "Kannada",
  "Odia",
  "Assamese",
  "Urdu",
  "Sanskrit",
  "Konkani",
  "Maithili",
  "Bodo",
  "Dogri",
  "Santali",
  "Sindhi",
  "Manipuri",
];

const SubmitTitle = () => {
  const [inputs, setInputs] = useState([{ title: "", language: "auto" }]);
  const [errors, setErrors] = useState([]);
  const [openModel, setOpenModal] = useState(false);
  const [modelData, setModelData] = useState({});
  const [feedback, setFeedBackData] = useState("");
  const [similarity, setMaxSimilarity] = useState(0);
  const [reports, setReports] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (index, field, value) => {
    const newInputs = [...inputs];
    newInputs[index][field] = value;
    setInputs(newInputs);

    if (field === "title") {
      const newErrors = [...errors];
      newErrors[index] = value.trim() === "" ? "Title is required" : "";
      setErrors(newErrors);
    }
  };

  const addInputPair = () => {
    if (inputs.length < 5) {
      setInputs([...inputs, { title: "", language: "" }]);
      setErrors([...errors, ""]);
    }
  };

  const removeInputPair = (index) => {
    const newInputs = inputs.filter((_, i) => i !== index);
    const newErrors = errors.filter((_, i) => i !== index);
    setInputs(newInputs);
    setErrors(newErrors);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setReports(null);
    const newErrors = inputs.map((input) =>
      input.title.trim() === "" ? "Title is required" : ""
    );
    setErrors(newErrors);

    if (newErrors.every((error) => error === "")) {
      let titles = [];
      inputs.forEach((element) => {
        titles.push(element.title);
      });

      try {
        const promises = inputs.map((input) =>
          fetch(
            `https://ajayreddy9-prgi.hf.space/verify-title/?new_title=${input.title}`
          ).then((response) => {
            if (!response.ok) {
              throw new Error(
                `Error: ${response.status} - ${response.statusText}`
              );
            }
            return response.json();
          })
        );

        const results = await Promise.all(promises);
        setLoading(false);
        setReports(results);
        console.log(results);
      } catch (error) {
        console.error(
          "An error occurred while verifying titles:",
          error.message
        );
      }
    }
  };

  const renderReport = (data, title, feedback, max_similarity) => {
    // console.log(max_similarity);
    return (
      <Box className="short-report-container">
        <h3 style={{ margin: "1rem" }}>Title : {title}</h3>
        <Button
          style={{ margin: "0.5rem", marginLeft: "1rem" }}
          variant="contained"
          onClick={() => {
            setOpenModal(true);
            setModelData(data);
            setFeedBackData(feedback);
            setMaxSimilarity(max_similarity);
          }}
        >
          View Report
        </Button>
      </Box>
    );
  };

  const renderModelContent = () => {
    return (
      <div className="model-content-container">
        <Button
          variant="contained"
          className="model-button"
          onClick={() => setOpenModal(false)}
        >
          Close
        </Button>
        <div className="model-sub-container">
          <RenderResponse
            results={modelData}
            feedback={feedback}
            max_similarity={similarity}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={`modal-bg ${openModel === true ? "modal-open" : ""}`}>
        {openModel === true && renderModelContent()}
      </div>
      <section className="submit-title-page">
        <h1>Submit Title</h1>
        <div className="form-container">
          <Box sx={{ maxWidth: 900, margin: "auto", mt: 4 }}>
            <form onSubmit={handleSubmit}>
              {inputs.map((input, index) => (
                <Grid
                  container
                  spacing={2}
                  key={index}
                  alignItems="center"
                  sx={{ mb: 2, justifyContent: "center" }}
                >
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label={`Title ${index + 1}*`}
                      value={input.title}
                      onChange={(e) =>
                        handleInputChange(index, "title", e.target.value)
                      }
                      variant="outlined"
                      error={!!errors[index]}
                      helperText={errors[index]}
                    />
                  </Grid>
                  {/* <Grid item xs={4}>
                    <TextField
                      select
                      fullWidth
                      label={`Language ${index + 1}`}
                      value={input.language}
                      onChange={(e) =>
                        handleInputChange(index, "language", e.target.value)
                      }
                      variant="outlined"
                    >
                      {languages.map((lang) => (
                        <MenuItem key={lang} value={lang}>
                          {lang}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid> */}
                  <Grid item xs={2}>
                    <IconButton
                      color="error"
                      onClick={() => removeInputPair(index)}
                      disabled={inputs.length === 1}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              ))}
              <Box sx={{ maxWidth: 400, margin: "auto", mt: 4, flex: "row" }}>
                <Button
                  variant="contained"
                  onClick={addInputPair}
                  disabled={inputs.length >= 5}
                  sx={{ mt: 2, mr: 2, width: "40%" }}
                >
                  Add Title
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2, width: "40%" }}
                >
                  Check Score
                </Button>
              </Box>
            </form>
          </Box>
          {reports !== null && (
            <section className="reports-section">
              <h2 className="heading">Reports</h2>
              {reports.map((eachReport) =>
                renderReport(
                  eachReport.results,
                  eachReport.title,
                  eachReport.feedback,
                  eachReport["max_similarity"]
                )
              )}
            </section>
          )}
        </div>
      </section>
    </>
  );
};

export default SubmitTitle;
